import { cn } from '../../lib/utils/classnameVariants';
import React from 'react';

export enum TableType {
  'default' = 'default',
  'compare' = 'compare',
}

export interface RowContent {
  rowHeader: string;
  cells: string[];
}

export interface TableListRowProps extends React.HTMLAttributes<HTMLTableRowElement>, RowContent {
  type: TableType;
  columns?: string[];
}

export const TableListRow = React.forwardRef<HTMLTableRowElement, TableListRowProps>(
  ({ type, columns, rowHeader, cells, className, ...props }, ref) => {
    return type === TableType.compare && columns ? (
      <>
        <tr {...props} ref={ref} className={cn('w-full', className)}>
          <th className="pb-2 pt-6 text-left text-sm font-medium" colSpan={cells.length}>
            {rowHeader}
          </th>
        </tr>
        <tr {...props}>
          {columns.map((column, index) => (
            <th key={index} className="py-4 pr-4 text-left text-xs font-normal last:pr-0 sm:pr-6 sm:text-sm">
              {column}
            </th>
          ))}
        </tr>
        <tr {...props}>
          {cells.map((cell, index) => (
            <td
              key={index}
              className="border-b border-b-black-900 pb-4 pr-4 text-xs font-medium last:pr-0 sm:pr-6 sm:text-sm"
            >
              {cell}
            </td>
          ))}
        </tr>
      </>
    ) : (
      <>
        <tr {...props} ref={ref} className={className}>
          <td className="pt-4 text-sm font-medium" colSpan={cells.length}>
            {rowHeader}
          </td>
        </tr>
        <tr {...props} className={className}>
          {cells.map((cell, index) => (
            <td
              key={index}
              className="shrink border-b border-b-black-50 py-4 pr-4 text-xs font-normal last:pr-0 sm:pr-6 sm:text-sm"
            >
              {cell}
            </td>
          ))}
        </tr>
      </>
    );
  },
);
